import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs/Observable";
import { BaseDiscountModel } from "../discount-models/BaseDiscountModel";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";

@Component({
  selector: "discount-management-delete-modal",
  templateUrl: "./discount-management-delete-modal.component.html",
  styleUrls: ["./discount-management-delete-modal.component.scss"],
})
export class DiscountManagementDeleteModalComponent implements OnInit {
  @ViewChild("content") public contentRef: TemplateRef<any>;
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  @Input("openModal") public openModal: Observable<BaseDiscountModel | false>;

  public modalText: string = "האם למחוק את הסבסוד?";

  public modalHeader: string = "אישור מחיקה";
  public data: BaseDiscountModel | false = false;
  public translations$: Observable<ITranslations>;

  constructor(
    private translationService: TranslationService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {
    this.translations$ = this.translationService.translations;
  }

  public open(content) {
    // @ts-ignore
    this.activeModal = this.modalService
      .open(content, {
        backdrop: true,
        backdropClass: "custom-event-backdropClass",
      })
      .result.then(
        (result) => {
          this.modalResult.emit(result === "delete" ? this.data : false);
        },
        (reason) => {
          this.modalResult.emit(false);
        }
      );
  }

  public ngOnInit(): void {
    this.openModal.subscribe((data) => {
      this.data = data;
      if (data) {
        this.open(this.contentRef);
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-management-delete-modal/discount-management-delete-modal.component.ts